import { PATH_SIGNUP_ME, PATH_SIGNUP_PETS } from './paths';

export const tosaRouteWhitelist = [PATH_SIGNUP_ME, PATH_SIGNUP_PETS];
